module.exports = __webpack_public_path__ + "img/Group-23.78bb5554.png";